import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { usePageErrorBoundary } from '../../library/providers/PageProvider';
import styles from './ExplorePage.module.scss';
import LiveqStarter from '@booking/pages/liveqHome/LiveqStarter';
const ExploreLiveqStarterPage = () => {
    const { t } = useTranslation();
    const errorBoundary = usePageErrorBoundary();
    return (_jsx("div", Object.assign({ className: "content" }, { children: _jsx("div", Object.assign({ className: classNames('container', styles.contentInner) }, { children: _jsx(LiveqStarter, {}) })) })));
};
export default observer(ExploreLiveqStarterPage);
